var KBResultsList = React.createClass({
  propTypes: {
    hits: React.PropTypes.arrayOf(React.PropTypes.object).isRequired,
    onEmailClicked: React.PropTypes.func.isRequired,
    onPreviewClicked: React.PropTypes.func.isRequired
  },

  render() {
    if (this.props.hits.length == 0) {
      return <span />
    }

    let showStars = RA.KBSearch.showRelevancyStars && RA.Utils.isNotBlank(RA.KBSearch.query.querytext);
	let queryText = RA.KBSearch.query.querytext;

	if (showStars) {
		queryText = queryText.split(/\s+/).slice(0,30).join(" ");
	}

    return (
      <ul className="solution-list">
        {this.props.hits.map(hit =>
          <KBResultItem
            key={hit.solution.id}
            hit={hit}
            showStars={showStars}
			queryText={queryText}
			showHitSummary={RA.KBSearch.showHitSummary}
            onEmailClicked={this.props.onEmailClicked}
            onPreviewClicked={this.props.onPreviewClicked}
            {...this.props} />
          )
        }
      </ul>
    )
  }
});